<!-- src/components/templates/PriceTag1.vue -->
<template>
  <div class="price-tag-container bg-white text-dark p-4 d-flex flex-column justify-content-between">
    <div>
      <!-- NAGŁÓWEK / LOGO -->
      <div class="row align-items-center mb-3">
        <div class="col-8">
          <!-- Jeśli masz dynamiczne logo dealera, możesz je tu podmienić -->
          <div class="logo-text">Perfect Car</div>
        </div>
        <div class="col-4 text-end">
          <div class="fs-5 fw-bold text-secondary">
            Nr: {{ car.ID || car.id || '????' }}
          </div>
        </div>
      </div>

      <hr class="border-2 border-dark mt-0 mb-4" />

      <!-- SIATKA PARAMETRÓW POJAZDU (2 KORUMNY) -->
      <div class="row g-3 mb-4">
        <!-- Marka -->
        <div class="col-6">
          <div class="spec-tile">
            <div class="spec-value">{{ car.make || '????' }}</div>
            <div class="spec-label">Marka</div>
          </div>
        </div>

        <!-- Model -->
        <div class="col-6">
          <div class="spec-tile">
            <div class="spec-value">{{ car.model || '????' }}</div>
            <div class="spec-label">Model</div>
          </div>
        </div>

        <!-- Rok produkcji -->
        <div class="col-6">
          <div class="spec-tile">
            <div class="spec-value">{{ car.productionYear || '????' }}</div>
            <div class="spec-label">Rok produkcji</div>
          </div>
        </div>

        <!-- Przebieg -->
        <div class="col-6">
          <div class="spec-tile">
            <div class="spec-value">
              {{ car.mileage ? Number(car.mileage).toLocaleString('pl-PL') : '????' }} km
            </div>
            <div class="spec-label">Przebieg</div>
          </div>
        </div>

        <!-- Pojemność skokowa / KM -->
        <div class="col-6">
          <div class="spec-tile">
            <div class="spec-value">
              {{ formatEngineCapacity(car.engineCCM) }} / {{ car.powerKM ? car.powerKM + ' KM' : '????' }}
            </div>
            <div class="spec-label">Pojemność skokowa / Konie mechaniczne</div>
          </div>
        </div>

        <!-- Paliwo -->
        <div class="col-6">
          <div class="spec-tile">
            <div class="spec-value">{{ car.fuelTypeName || car.fuelType || '????' }}</div>
            <div class="spec-label">Paliwo</div>
          </div>
        </div>
      </div>

      <!-- SEKCJA WYPOSAŻENIA (2 KOLUMNY) -->
      <div v-if="formattedEquipment.length" class="mt-4">
        <h6 class="fw-bold border-bottom pb-2 mb-3 text-uppercase text-secondary">
          Wyposażenie
        </h6>
        <div class="row g-2 equipment-list">
          <div
            v-for="(item, index) in formattedEquipment"
            :key="index"
            class="col-6 equipment-item"
          >
            <i class="bi bi-dot me-1"></i>{{ item }}
          </div>
        </div>
      </div>
    </div>

    <!-- SEKCJA CENOWA (NA DOLE STRONY) -->
    <div class="price-section text-center mt-4">
      <div class="price-box py-3 rounded">
        <div class="price-value display-4 fw-black">
          {{ car.price ? Number(car.price).toLocaleString('pl-PL') : '????' }} PLN
        </div>
        <div class="price-subtitle fw-bold text-uppercase mt-1">
          CENA Z GWARANCJĄ
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  car: {
    type: Object,
    required: true
  }
})

// Formatowanie pojemności cm3 na litry (np. 1998 -> 2.0)
const formatEngineCapacity = (ccm) => {
  if (!ccm) return '????'
  const liters = (Number(ccm) / 1000).toFixed(1)
  return `${liters}`
}

// Normalizacja wyposażenia (obsługuje tablicę obiektów lub ciągów znaków)
const formattedEquipment = computed(() => {
  if (!props.car?.equipment) return []
  if (Array.isArray(props.car.equipment)) {
    return props.car.equipment.map(eq => (typeof eq === 'object' ? eq.name : eq))
  }
  return []
})
</script>

<!-- nie moze byc tutaj setup bo nie zadziala-->
<script>
export const templateMeta = {
  id: 'cenowka-cargwarant-2',
  name: 'Przykłąd drugiego wzoru (Perfect Car)',
  orientation: 'portrait' // 👈 Dodajesz właściwość
}
</script>

<style scoped>
.price-tag-container {
  width: 210mm;
  min-height: 296mm; /* Idealne dopasowanie pod pojedynczą kartkę A4 */
  box-sizing: border-box;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  margin: 0 auto;
  background-color: #ffffff;
}

.logo-text {
  font-family: 'Brush Script MT', cursive, sans-serif;
  font-size: 3.2rem;
  font-weight: bold;
  font-style: italic;
  color: #2b2b2b;
  letter-spacing: 1px;
}

.spec-tile {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px 14px;
  background-color: #f9f9f9;
}

.spec-value {
  font-size: 1.35rem;
  font-weight: 800;
  color: #111111;
  line-height: 1.2;
}

.spec-label {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 600;
  text-uppercase: uppercase;
  margin-top: 4px;
}

.equipment-list {
  font-size: 0.88rem;
  color: #333333;
}

.equipment-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price-box {
  background-color: #f1f3f5;
  border: 2px solid #212529;
}

.price-value {
  font-size: 3.5rem;
  font-weight: 900;
  color: #000000;
  letter-spacing: -1px;
  line-height: 1;
}

.price-subtitle {
  font-size: 1.1rem;
  letter-spacing: 1.5px;
  color: #212529;
}

@media print {
  .price-tag-container {
    width: 210mm;
    height: 297mm;
    padding: 15mm !important;
  }
}
</style>